import PropertyDetail from "../../commonComponents/productDetail/PropertyDetail";

const PropertyClassicContainer = () => {
  return <PropertyDetail />;
};

export default PropertyClassicContainer;
